import Flex from '@Components/Bases/Flex';
import FormRadio from '@Components/Form/FormRadio';
import { Box, InputLabel } from '@mui/material';
import { BusinessTypes } from '../NatureOfBusinessFormProvider/types';
import { CompleteSectionFormValues } from '@Utils/Types/FormValuesTypes';
import { useWatch } from 'react-hook-form';

const businessType = [
  {
    value: BusinessTypes.MANUFACTURING_SERVICE,
    label: 'ภาคผลิต/บริการ',
  },
  {
    value: BusinessTypes.FINANCIAL_INSTITUTIONS,
    label: 'สถาบันทางการเงิน',
  },
];
const TypeOfBusiness = () => {
  const { isCompletedTh, isCompletedEn } =
    useWatch({
      name: 'productInformation.completedSection',
    }) ?? ({} as CompleteSectionFormValues);

  return (
    <Box width={1}>
      <Flex width={1} alignItems={'baseline'}>
        <InputLabel
          sx={{ textAlign: 'right', width: 1, maxWidth: 350 }}
          required
        >
          กรุณาเลือกลักษณะธุรกิจบริษัทของท่าน
        </InputLabel>
        <Box ml={3} sx={{ width: 1 }}>
          <FormRadio
            name={'productInformation.businessType'}
            options={businessType}
            disabled={isCompletedTh || isCompletedEn}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default TypeOfBusiness;
